export const smallChartWidth = "130";
export const chartWidth = "185";

export function chartOptions(indicatorStyle, fontSize, isLabelMatchIndicator) {
    return {
        labels: [""],
        fill: {
            type: "solid",
            colors: [indicatorStyle.color],
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: "70%",
                },
                track: {
                    background: "#C4C4C4",
                    strokeWidth: "35%",
                    margin: 2,
                },
                dataLabels: {
                    showOn: "always",
                    value: {
                        offsetY: -8,
                        color: isLabelMatchIndicator ? indicatorStyle.color : "#082254",
                        fontSize: fontSize === null ? "16px" : fontSize,
                        show: true,
                        fontFamily: "'Montserrat', 'Open Sans', Arial, sans-serif",
                        fontWeight: "600",
                    },
                },
            },
        },
    };
}
